import React from 'react';
import { Button } from 'ui';
import { useLocaleContext } from 'context/LocaleContext';
import { readCachedLanguageDictionary } from 'store/actions/languageDictionary';
import styles from './styles.module.scss';

const LanguageButtons: React.FC<any> = ({}) => {
    const { locale, setLocale } = useLocaleContext();

    const dictionary = readCachedLanguageDictionary();

    return (
        <>
            {dictionary &&
                Object.keys(dictionary).map((entries: any) => {
                    if (entries !== 'loading' && entries !== 'failed') {
                        return (
                            <Button
                                key={entries}
                                className={
                                    (locale === entries) ? styles.localeSwitchActive : styles.localeSwitch
                                }
                                onClick={() => setLocale(entries)}
                                message={entries}/>
                        );
                    }
                    return null;
                })}
        </>
    );
};
export default LanguageButtons;
